import React from 'react';

import { ADMIN_REPORTS } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { ReportsIcon } from '@Generic/icons';
import { ADMIN_REPORTS_PAGE_PATH } from '@ApplicationWide/constants/routes';

const ReportsPage = React.lazy(() => import('../../../pages/Admin/Reports/ReportsPage'));

export default {
  label: 'navigation.admin.reports',
  group: ADMIN,
  to: ADMIN_REPORTS_PAGE_PATH,
  route: ADMIN_REPORTS_PAGE_PATH,
  component: ReportsPage,
  icon: <ReportsIcon />,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_REPORTS,
  area: ADMIN_REPORTS,
  hasNavBar: true,
};
